<template>
    <button class="quiz-button" :class="buttonClass" @click="$emit('click')">
        <SpinLoader color="#fff" :width="(button.font.size * button.font.height) / 100" v-if="loading" />

        <span :class="{ 'visibility-hidden': loading }">
            <template v-if="isAlternative">
                {{ button.titleAlternative || t(`expert.quiz-buttons.${button.type}.title_alt`) }}
            </template>

            <template v-else-if="isOneQuestion">
                {{ button.titleOneQuestion || t(`expert.quiz-buttons.${button.type}.title_one_question`) }}
            </template>

            <template v-else>
                {{ button.title || t(`expert.quiz-buttons.${button.type}.title`) }}
            </template>
        </span>
    </button>
</template>

<script>
import { SettingsButton } from "./settings-button"
import {
    addCSSClass,
    resolveBorder,
    resolveFont,
    resolvePadding,
    resolveShadow
} from "@components/Builder/widget/utils/style"
import SpinLoader from "@components/Loaders/SpinLoader.vue"

export default {
    components: { SpinLoader },
    props: {
        isAlternative: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        isOneQuestion: {
            type: Boolean,
            default: false
        },
        button: {
            type: SettingsButton,
            default: null
        }
    },
    name: "QuizButton",
    computed: {
        buttonClass() {
            return addCSSClass(this.buttonStyle, this.button.type)
        },
        buttonStyle() {
            return {
                ...resolvePadding(this.button.padding),
                ...resolveFont(this.button.font),
                ...resolveBorder(this.button.border),
                ...resolveShadow(this.button.shadow),
                whiteSpace: "nowrap",
                backgroundColor: this.button.background,
                height: "max-content"
            }
        }
    }
}
</script>

<style scoped lang="scss">
.visibility-hidden {
    visibility: hidden;
    height: 0;
    overflow: hidden;
    display: block;
}
.quiz-button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    &:hover {
        filter: brightness(90%);
    }
}
</style>
